import { FunctionComponent } from 'react';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useSelector } from '@cbridge-utils/react-redux';
import { authUserDataSelector } from '@cbridge-packages/auth';

const EmailSection = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
}));

/**
 * Email line at the top of the account popover. The avatar and the name are not repeated here:
 * both are already in the header button that opens the popover. Renders nothing without an email.
 */
export const AccountEmail: FunctionComponent = () => {
  const user = useSelector(authUserDataSelector);

  if (!user?.email) {
    return null;
  }

  return (
    <>
      <EmailSection>
        <Typography variant={'body2'} noWrap={true}>
          {user.email}
        </Typography>
      </EmailSection>
      <Divider />
    </>
  );
};
